import * as api from '../../api/api-informes-administracion';
import {
    OBTENER_LLAVES,
    GET_CONFIG_FORMINF,
    GET_TIPOS_INFORME,
    GET_COMPANIAS,
    GET_ESTADOS,
    GET_SITUACIONES,
    GET_CRITERIOS_FECHA,
    GET_CRITERIOS_PEND,
    GET_INFORMES_PREVIOS,
    POST_GENERAR_INFORME,
    GET_PROVEEDORES
} from '../types';


export const obtenerDatosLlaves = (llaves) => ({
    type:OBTENER_LLAVES,
    payload: llaves
});
export const configuracionFormAction = (query) => ({
    type: GET_CONFIG_FORMINF,
    payload: api.getConfiguracionForm(query)
});
export const obtenerTiposInforme = (query) => ({
    type: GET_TIPOS_INFORME,
    payload: api.getDetalles(query)
});
export const obtenerCompanias = (query) => ({
    type: GET_COMPANIAS,
    payload: api.getCompanias(query)
});
export const obtenerEstados = (query) => ({
    type: GET_ESTADOS,
    payload: api.getEstadoByGestion(query)
});
export const obtenerSituaciones = (query) => ({
    type: GET_SITUACIONES,
    payload: api.getDetalles(query)
});
export const obtenerCriteriosFecha = (query) => ({
    type: GET_CRITERIOS_FECHA,
    payload: api.getDetalles(query)
});
export const obtenerCriteriosPendiente = (query) => ({
    type: GET_CRITERIOS_PEND,
    payload: api.getDetalles(query)
});
export const obtenerInformesPrevios = (query) => ({
    type: GET_INFORMES_PREVIOS,
    payload: api.getInformesPrevios(query)
});
export const generarInforme = (data) => ({
    type: POST_GENERAR_INFORME,
    payload: api.postGenerarInforme(data)
});
export const obtenerProveedores = (query) => ({
    type: GET_PROVEEDORES,
    payload: api.getProveedores(query)
});